import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getTemplatePageData } from './api';
import type { TemplatePageDataErrorCode } from './types';

export const {
	Context: TemplatePageDataContext,
	Provider: TemplatePageDataContextProvider,
	useContext: useTemplatePageData,
	useAsyncData: useTemplatePageDataFromApi,
	prefetchAsyncData: prefetchTemplatePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'TemplatePageDataContext',
	dataProperty: 'pageData',
	getData: getTemplatePageData,
	getUniqueId: (slug) => slug ?? '',
	errorHandler: pageDataErrorHandler<TemplatePageDataErrorCode>(),
});
